/* eslint-disable react/prop-types */
import { h, Fragment } from 'preact';
import { useEffect } from 'preact/hooks';
import useCurbsiderReducer from '../hooks/useCurbsideReducer';
import ATCButton from './ATCButton';
import OptionManager from './OptionManager';
import { checkIfOpen } from '../utils/openSign';
import useOpenSign from '../hooks/useOpenSign';
import AddonManager from './addons/AddonManager';

const App = ({ initialOptions, milkOption, baseProduct, storeHours }) => {
  const isOpen = useOpenSign();

  const [optionState, dispatch] = useCurbsiderReducer({
    initialOptions,
    baseProduct,
  });

  useEffect(() => {
    dispatch({
      type: 'UPDATE_TOTAL',
    });
  }, [optionState.activeAddons, optionState.activeVariant]);

  useEffect(() => {
    checkIfOpen(storeHours);
  }, []);

  if (isOpen === undefined) return <p>loading...</p>;
  if (baseProduct.available === false)
    return (
      <div style="margin: 1.25em 0px;">
        <p>{baseProduct.title} is unavailable! sorry!</p>
      </div>
    );
  if (isOpen === false)
    return (
      <div style="margin: 1.25em 0px;">
        <p className="h4">Were not taking online orders right now.</p>
        <p>Stop by the cafe or check back here soon!</p>
      </div>
    );

  return (
    <Fragment>
      {!optionState.hasAddedToCart && (
        <div style="margin: 1.25em 0px;">
          <h4>Options</h4>
          {/* Manage Required Options to determine variant */}
          <OptionManager product={baseProduct} dispatch={dispatch} />
          {/* Manage Additional / optional addons  */}
          {(baseProduct.type.includes('Hot Drink') ||
            baseProduct.type.includes('Cold Drink')) && (
            <AddonManager
              optionState={optionState}
              dispatch={dispatch}
              milkOption={milkOption}
            />
          )}
          <details style="border: none;">
            <summary style="font-size: 1em; color: inherit;">
              would you like to change something else?
            </summary>
            <textarea
              id="product-notes"
              style="width: 100%"
              placeholder="please list allergies, things you'd like removed, etc"
            ></textarea>
          </details>
        </div>
      )}
      <div style="margin: 1.25em 0px;">
        <ATCButton dispatch={dispatch} state={optionState} />
      </div>
    </Fragment>
  );
};

export default App;
